module.exports = __webpack_public_path__ + "static/media/Talkative-logo-client-page-01.0bdaea70.png";